var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner-banner"},[_c('img',{attrs:{"src":_vm.banner.img,"alt":_vm.banner.title}}),_c('div',{staticClass:"txt wp"},[_c('h3',[_vm._v(_vm._s(_vm.banner.title))]),_c('p',[_vm._v(_vm._s(_vm.banner.desc))])])])}
var staticRenderFns = []

export { render, staticRenderFns }